"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSignedUrlsToBroadcast = addSignedUrlsToBroadcast;
exports.attendeesWithCameraOn = void 0;
exports.combineSources = combineSources;
exports.findAndUpdateEmptySourceTitle = findAndUpdateEmptySourceTitle;
exports.findAndUpdateSource = findAndUpdateSource;
exports.getAttendeeIds = getAttendeeIds;
exports.getAttendeesNextMuteStatuses = getAttendeesNextMuteStatuses;
exports.getBroadcastSourcesFromLayers = getBroadcastSourcesFromLayers;
exports.getGroupSources = getGroupSources;
exports.getMediaSourceValueObject = getMediaSourceValueObject;
exports.getSceneLayerIds = getSceneLayerIds;
exports.getScreenShareCount = getScreenShareCount;
exports.getShouldApproveScreenShares = void 0;
exports.getSignedUrlsResponse = getSignedUrlsResponse;
exports.getStartedOn = getStartedOn;
exports.getUpdatedSceneLayers = getUpdatedSceneLayers;
exports.hasMeetingExceededCameraLimit = void 0;
exports.isCameraSource = isCameraSource;
exports.isMediaSource = isMediaSource;
exports.isMediaSourceExcludeAudio = isMediaSourceExcludeAudio;
exports.isSourceInLayer = isSourceInLayer;
exports.mapSignedUrlsToSources = mapSignedUrlsToSources;
exports.orderSources = orderSources;
exports.readFileAsBinary = readFileAsBinary;
exports.retainPDFURLsInSources = retainPDFURLsInSources;
exports.sourcesWithPreviousDisconnectedState = sourcesWithPreviousDisconnectedState;
exports.toggleStatus = toggleStatus;
exports.transferAudioSourceLayer = transferAudioSourceLayer;
exports.updateProgramIfBackgroundImagePresignedUrlExpired = updateProgramIfBackgroundImagePresignedUrlExpired;
exports.uploadEventDoc = uploadEventDoc;
exports.uploadForm = uploadForm;
exports.willExceedCameraLimit = willExceedCameraLimit;
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _sources = require("@studio/sources");
var _constants = require("@studio/constants");
var _logger = require("@studio/logger");
var _underscore = _interopRequireDefault(require("underscore"));
var _constants2 = require("../constants");
var _time = require("./time");
var _feature = require("@studio/feature.flags");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @param {Array} sources
 */
function orderSources(sources) {
  return _toConsumableArray(sources).sort(function (a, b) {
    return a.order - b.order;
  });
}

/**
 * Get layer broadcast sources
 * Need to make sure the layer sources exist in the broadcastSources array
 */
function getBroadcastSourcesFromLayers(layers, broadcastSources) {
  return layers.map(function (layer) {
    return layer.source;
  }).filter(function (source) {
    return broadcastSources.find(function (bs) {
      return [source._id, source.value].includes(bs._id);
    });
  });
}
var signedURLsCache = {
  lastUpdated: new Date().getTime()
};

/**
 * Get an object value even when the value is in "legacy" format for media sources (used to be just the event doc ID)
 * @param {*} value
 */
function getMediaSourceValueObject(value) {
  return typeof value === 'string' ? {
    eventDocId: value
  } : value;
}
function getSignedUrlsResponse(items, signedUrls) {
  var response = items.map(function (item) {
    if (item === 'SCENE_LAYER') {
      return item;
    }
    var _item$source = item.source,
      value = _item$source.value,
      type = _item$source.type;
    if (![_constants.IMAGE_FILE, _constants.VIDEO_FILE, _constants.AUDIO_FILE, _constants.PDF_FILE].includes(type) || (value === null || value === void 0 ? void 0 : value.type) === _constants.STOCK_MEDIA) {
      return item;
    }
    var objectValue = getMediaSourceValueObject(value);
    return _objectSpread(_objectSpread({}, item), {}, {
      layer: _objectSpread({}, item.layer),
      source: _objectSpread(_objectSpread({}, item.source), {}, {
        value: _objectSpread(_objectSpread({}, objectValue), {}, {
          url: signedUrls[objectValue.eventDocId]
        })
      })
    });
  });
  return response;
}

/**
 *
 * @param {*} raw - url string eg. 'url(https://studio-docs-sg50-cvent-event-dev.s3.amazonaws.com/teams/56fd701dabdd86bf147cc9ba/events/56fd701dabdd86bf147cc9c1/docs/867507_Studio%20Background%203-1_1021120-754cd79d-1619176450881.png?AWSAccessKeyId=ASIAYRZKHVFTLNWRLO4I&Expires=1718016149)'
 * @returns '/teams/56fd701dabdd86bf147cc9ba/events/56fd701dabdd86bf147cc9c1/docs/867507_Studio%20Background%203-1_1021120-754cd79d-1619176450881.png'
 */
function getResourceS3Key(raw) {
  var matches = raw.match(/:\/\/(.[^/]+)(.*)/);
  var parsedUrl = new URL("http://".concat(matches[1]).concat(matches[2]));
  return parsedUrl.pathname;
}

/**
 * This function checks the broadcast background layerSource objects to find a match with the program style background image.
 * If a match is found, it updates the program background image with the layer source URL from the background layerSource,
 * ensuring that a valid URL is used for the background style.
 * @param {*} broadcast
 * @param {*} teamId
 * @param {*} eventId
 * @param {*} apiClient
 */
function updateProgramIfBackgroundImagePresignedUrlExpired(_x, _x2, _x3, _x4) {
  return _updateProgramIfBackgroundImagePresignedUrlExpired.apply(this, arguments);
}
function _updateProgramIfBackgroundImagePresignedUrlExpired() {
  _updateProgramIfBackgroundImagePresignedUrlExpired = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(broadcast, teamId, eventId, apiClient) {
    var programBackgroundImage, programBackgroundImageS3Key;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          programBackgroundImage = broadcast && broadcast.program && broadcast.program.style && broadcast.program.style.backgroundImage || '';
          if (!(!programBackgroundImage || !broadcast.backgrounds)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          programBackgroundImageS3Key = getResourceS3Key(programBackgroundImage);
          _underscore["default"].each(broadcast.backgrounds, /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(background) {
              var backgroundImagePresignedUrl;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    backgroundImagePresignedUrl = background.source.value.url;
                    if (!(backgroundImagePresignedUrl && getResourceS3Key(backgroundImagePresignedUrl) === programBackgroundImageS3Key && programBackgroundImage != "url(".concat(backgroundImagePresignedUrl, ")"))) {
                      _context.next = 5;
                      break;
                    }
                    broadcast.program.style.backgroundImage = "url(".concat(backgroundImagePresignedUrl, ")");
                    _context.next = 5;
                    return apiClient.broadcast.updateProgram(teamId, eventId, broadcast._id, broadcast.program);
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x18) {
              return _ref.apply(this, arguments);
            };
          }());
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _updateProgramIfBackgroundImagePresignedUrlExpired.apply(this, arguments);
}
function mapSignedUrlsToSources(_x5, _x6, _x7, _x8) {
  return _mapSignedUrlsToSources.apply(this, arguments);
}
function _mapSignedUrlsToSources() {
  _mapSignedUrlsToSources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(items, apiClient, team, event) {
    var isS3ProxyStatusUpdate,
      minutes,
      isValidCache,
      eventDocIds,
      _yield$apiClient$even,
      urls,
      response,
      message,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isS3ProxyStatusUpdate = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
          if (!(items == null || items.length === 0)) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", []);
        case 3:
          minutes = (0, _time.getMinutesDifference)(signedURLsCache.lastUpdated, new Date().getTime());
          isValidCache = minutes < _constants2.SIGNED_URLS_CACHE_TIMEOUT_VALUE;
          eventDocIds = items.reduce(function (acc, item) {
            if (item === 'SCENE_LAYER') {
              return acc;
            }
            var _item$source2 = item.source,
              value = _item$source2.value,
              type = _item$source2.type;
            if (![_constants.IMAGE_FILE, _constants.VIDEO_FILE, _constants.AUDIO_FILE, _constants.PDF_FILE].includes(type) || (value === null || value === void 0 ? void 0 : value.type) === _constants.STOCK_MEDIA) {
              return acc;
            }
            var objectValue = getMediaSourceValueObject(value);
            if (signedURLsCache[objectValue.eventDocId] && isValidCache && !isS3ProxyStatusUpdate) {
              return acc;
            }
            acc.push(objectValue.eventDocId);
            return acc;
          }, []);
          /**
           * We won't make an API call when eventDocIds are empty.
           */
          if (eventDocIds.length) {
            _context3.next = 10;
            break;
          }
          if (!isValidCache) {
            _context3.next = 9;
            break;
          }
          return _context3.abrupt("return", getSignedUrlsResponse(items, signedURLsCache));
        case 9:
          return _context3.abrupt("return", []);
        case 10:
          _context3.prev = 10;
          _context3.next = 13;
          return apiClient.eventDoc.getSignedUrls(team, event, {
            eventDocs: eventDocIds
          });
        case 13:
          _yield$apiClient$even = _context3.sent;
          urls = _yield$apiClient$even.urls;
          // update signedURLCache including last updated timestamp.
          signedURLsCache = _objectSpread(_objectSpread(_objectSpread({}, signedURLsCache), urls), {}, {
            lastUpdated: new Date().getTime()
          });
          response = getSignedUrlsResponse(items, signedURLsCache);
          return _context3.abrupt("return", response);
        case 20:
          _context3.prev = 20;
          _context3.t0 = _context3["catch"](10);
          // we probably want to dispatch an error handling action in here
          message = "An error occurred calling eventDoc.getSignedUrls to team: ".concat(team, " event: ").concat(event);
          (0, _logger.sendToDatadog)('actions-utils', _context3.t0, message, true);
          return _context3.abrupt("return", []);
        case 25:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[10, 20]]);
  }));
  return _mapSignedUrlsToSources.apply(this, arguments);
}
function addSignedUrlsToBroadcast(_x9, _x10, _x11, _x12) {
  return _addSignedUrlsToBroadcast.apply(this, arguments);
}
/**
 * Repopulate scene with the correct media audio source
 * @param {{}} sourceScene
 * @param {{}} targetScene
 * @returns {{}}
 */
function _addSignedUrlsToBroadcast() {
  _addSignedUrlsToBroadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(broadcast, apiClient, teamId, eventId) {
    var _broadcast, overlays, backgrounds, globalSceneLayers, program, modifiedOverlays, modifiedBackgrounds, modifiedGlobalSceneLayers, modifiedMediaLayers, updatedProgram, updatedBroadcast;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _broadcast = broadcast, overlays = _broadcast.overlays, backgrounds = _broadcast.backgrounds, globalSceneLayers = _broadcast.globalSceneLayers, program = _broadcast.program;
          _context4.next = 3;
          return mapSignedUrlsToSources(overlays, apiClient, teamId, eventId);
        case 3:
          modifiedOverlays = _context4.sent;
          _context4.next = 6;
          return mapSignedUrlsToSources(backgrounds, apiClient, teamId, eventId);
        case 6:
          modifiedBackgrounds = _context4.sent;
          _context4.next = 9;
          return mapSignedUrlsToSources(globalSceneLayers, apiClient, teamId, eventId);
        case 9:
          modifiedGlobalSceneLayers = _context4.sent;
          if (!program) {
            _context4.next = 16;
            break;
          }
          _context4.next = 13;
          return mapSignedUrlsToSources(program.layers, apiClient, teamId, eventId);
        case 13:
          modifiedMediaLayers = _context4.sent;
          updatedProgram = _objectSpread(_objectSpread({}, program), {}, {
            layers: modifiedMediaLayers
          });
          broadcast = _objectSpread(_objectSpread({}, broadcast), {}, {
            program: updatedProgram
          });
        case 16:
          updatedBroadcast = _objectSpread(_objectSpread({}, broadcast), {}, {
            overlays: modifiedOverlays,
            backgrounds: modifiedBackgrounds,
            globalSceneLayers: modifiedGlobalSceneLayers
          });
          updateProgramIfBackgroundImagePresignedUrlExpired(updatedBroadcast, teamId, eventId, apiClient);
          return _context4.abrupt("return", updatedBroadcast);
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _addSignedUrlsToBroadcast.apply(this, arguments);
}
function transferAudioSourceLayer(sourceScene, targetScene) {
  var _sourceScene$layers;
  var sourceSceneAudioLayer = sourceScene === null || sourceScene === void 0 || (_sourceScene$layers = sourceScene.layers) === null || _sourceScene$layers === void 0 ? void 0 : _sourceScene$layers.find(function (layer) {
    return (0, _sources.isAudioSource)(layer === null || layer === void 0 ? void 0 : layer.source);
  });
  if (!sourceSceneAudioLayer) return targetScene;
  var targetSceneAudioLayerIndex;
  var sceneAudioLayer = targetScene.layers.find(function (layer, index) {
    targetSceneAudioLayerIndex = index;
    return (0, _sources.isAudioSource)(layer.source);
  });
  if (!sceneAudioLayer) {
    targetScene.layers.push(sourceSceneAudioLayer);
    return targetScene;
  }
  targetScene.layers[targetSceneAudioLayerIndex] = sourceSceneAudioLayer;
  return targetScene;
}

/**
 * Function to combine sources & swap audio files only if an audio file is already in program
 */
function combineSources(programSources, source) {
  /** Find existing audio sources */
  var audioSourceIndex = programSources.findIndex(function (ps) {
    return (0, _sources.isAudioSource)(ps);
  });
  /** Update incoming source to be unhidden */
  var incomingSource = _objectSpread(_objectSpread({}, source), {}, {
    hidden: false
  });
  /** Update the index of existing audio file in program sources with the new incoming audio file source */
  if (audioSourceIndex >= 0 && (0, _sources.isAudioSource)(source)) {
    programSources[audioSourceIndex] = incomingSource;
    return programSources;
  }
  return [incomingSource].concat(_toConsumableArray(programSources));
}
function uploadForm(_x13, _x14) {
  return _uploadForm.apply(this, arguments);
}
function _uploadForm() {
  _uploadForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(path, keyVals) {
    var config,
      onFailedCallback,
      SLIProps,
      formData,
      _ref2,
      trackContentUploadedSLICallback,
      _ref2$source,
      source,
      _ref2$externalVideoId,
      externalVideoId,
      _ref2$fileSize,
      fileSize,
      res,
      _source$isDragAndDrop,
      _source$isMultiFileUp,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          config = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
          onFailedCallback = _args5.length > 3 ? _args5[3] : undefined;
          SLIProps = _args5.length > 4 ? _args5[4] : undefined;
          formData = new FormData();
          _underscore["default"].each(keyVals, function (val, key) {
            formData.append(key, val);
          });
          _ref2 = SLIProps || {}, trackContentUploadedSLICallback = _ref2.trackContentUploadedSLICallback, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? {} : _ref2$source, _ref2$externalVideoId = _ref2.externalVideoId, externalVideoId = _ref2$externalVideoId === void 0 ? '' : _ref2$externalVideoId, _ref2$fileSize = _ref2.fileSize, fileSize = _ref2$fileSize === void 0 ? 0 : _ref2$fileSize;
          _context5.prev = 6;
          _context5.next = 9;
          return _axios["default"].post(path, formData, config);
        case 9:
          res = _context5.sent;
          return _context5.abrupt("return", res.data);
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](6);
          console.error(_context5.t0);
          if (onFailedCallback) {
            onFailedCallback();
          }
          trackContentUploadedSLICallback === null || trackContentUploadedSLICallback === void 0 || trackContentUploadedSLICallback({
            title: source === null || source === void 0 ? void 0 : source.title,
            fileType: source === null || source === void 0 ? void 0 : source.type,
            extension: source === null || source === void 0 ? void 0 : source.ext,
            isDragAndDrop: (_source$isDragAndDrop = source === null || source === void 0 ? void 0 : source.isDragAndDrop) !== null && _source$isDragAndDrop !== void 0 ? _source$isDragAndDrop : false,
            isMultiFileUpload: (_source$isMultiFileUp = source === null || source === void 0 ? void 0 : source.isMultiFileUpload) !== null && _source$isMultiFileUp !== void 0 ? _source$isMultiFileUp : false,
            externalVideoId: externalVideoId,
            fileSize: fileSize,
            error: _context5.t0
          });
        case 18:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[6, 13]]);
  }));
  return _uploadForm.apply(this, arguments);
}
function uploadEventDoc(_x15, _x16, _x17) {
  return _uploadEventDoc.apply(this, arguments);
}
function _uploadEventDoc() {
  _uploadEventDoc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(teamId, eventId, file) {
    var studioMedia,
      parentFolderId,
      config,
      onFailedCallback,
      trackContentUploadedSLICallback,
      source,
      externalVideoId,
      fileSize,
      keyVals,
      payload,
      SLIProps,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          studioMedia = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : false;
          parentFolderId = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : undefined;
          config = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : {};
          onFailedCallback = _args6.length > 6 ? _args6[6] : undefined;
          trackContentUploadedSLICallback = _args6.length > 7 ? _args6[7] : undefined;
          source = _args6.length > 8 ? _args6[8] : undefined;
          externalVideoId = _args6.length > 9 ? _args6[9] : undefined;
          fileSize = _args6.length > 10 ? _args6[10] : undefined;
          keyVals = {
            params: JSON.stringify({
              teamId: teamId,
              eventId: eventId
            }),
            file: file
          };
          payload = {};
          if (parentFolderId) {
            payload.parentFolderId = parentFolderId;
          }
          if (studioMedia) {
            payload.studioMedia = studioMedia;
          }
          keyVals.payload = JSON.stringify(payload);
          SLIProps = {
            trackContentUploadedSLICallback: trackContentUploadedSLICallback,
            source: source,
            externalVideoId: externalVideoId,
            fileSize: fileSize
          };
          return _context6.abrupt("return", uploadForm('/api/upload/eventDoc.create', keyVals, config, onFailedCallback, SLIProps));
        case 15:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _uploadEventDoc.apply(this, arguments);
}
function isMediaSourceExcludeAudio(source) {
  return [_constants.VIDEO_FILE, _constants.IMAGE_FILE, _constants.MEDIA, _constants.PDF_FILE].includes(source.type);
}

/** Reducer util function to find and update broadcast sources */
function findAndUpdateSource(oldSources, updatedSources) {
  return oldSources.map(function (s) {
    var updatedSource = _underscore["default"].find(updatedSources, function (us) {
      return us._id === s._id;
    });
    return !!updatedSource ? updatedSource : s;
  });
}

/*
  This function sets the title of sources without titles to an empty string
*/
function findAndUpdateEmptySourceTitle(sources) {
  return sources.map(function (s) {
    if (!s.title) {
      s.title = '';
    }
    return s;
  });
}

/** Reducer util function to find sources with disconnected state */
function sourcesWithPreviousDisconnectedState(newSources, oldSources) {
  return newSources.map(function (s) {
    var oldSource = _underscore["default"].find(oldSources, function (oldSource) {
      return oldSource._id === s._id;
    });
    if (oldSource) return _objectSpread(_objectSpread({}, s), {}, {
      disconnected: oldSource.disconnected,
      isInitializing: oldSource.isInitializing || false
    });
    return s;
  });
}
function getAttendeeIds(sources) {
  return sources.filter(function (source) {
    return (0, _sources.isCameraPresenter)(source);
  }).map(function (source) {
    return (source === null || source === void 0 ? void 0 : source.value) === _constants.UNASSIGNED ? "".concat(_constants.UNASSIGNED, "-").concat(source === null || source === void 0 ? void 0 : source._id) : source === null || source === void 0 ? void 0 : source.value;
  });
}

/** We want to unmute all staged sources and mute all other sources */
function getAttendeesNextMuteStatuses(stagedSources, broadcastSources) {
  var stagedAttendeeIds = getAttendeeIds(stagedSources);
  var allAttendeeIds = getAttendeeIds(broadcastSources);
  var nextMuteStatuses = allAttendeeIds.reduce(function (memo, attendeeId) {
    var isMuted = !stagedAttendeeIds.includes(attendeeId);
    return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, attendeeId, isMuted));
  }, {});
  return nextMuteStatuses;
}

/**
 * Util for toggling the hidden status of an banners, backgrounds
 * with the following structure [{ _id, layer: {}, source: {}}]
 * we can only have one un-hidden at a time
 */
function toggleStatus(itemId, items) {
  var _items$reduce;
  return (_items$reduce = items === null || items === void 0 ? void 0 : items.reduce(function (acc, item) {
    var source = item.source,
      _id = item._id;
    var isItemHidden = !(_id === itemId && source.hidden);
    return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, item), {}, {
      source: _objectSpread(_objectSpread({}, source), {}, {
        hidden: isItemHidden
      })
    })]);
  }, [])) !== null && _items$reduce !== void 0 ? _items$reduce : [];
}
function isSourceInLayer(source, layers) {
  var sourceId = source._id;
  return layers.some(function (layer) {
    return layer.source._id === sourceId;
  });
}
function getScreenShareCount(sources) {
  return sources.filter(function (s) {
    return s.type === _constants.SCREEN_PRESENTER;
  }).length;
}
function isMediaSource(sourceType) {
  return [_constants.VIDEO_FILE, _constants.AUDIO_FILE, _constants.IMAGE_FILE, _constants.PDF_FILE, _constants.MEDIA].includes(sourceType);
}
function isCameraSource(sourceType) {
  return sourceType === _constants.CAMERA_PRESENTER;
}
function getGroupSources(sources, groupType) {
  if (isMediaSource(groupType)) {
    return sources.filter(function (s) {
      return isMediaSource(s.type);
    });
  }
  if (isCameraSource(groupType)) {
    return sources.filter(function (s) {
      return isCameraSource(s.type);
    });
  }
}
function getStartedOn(isPlaying) {
  var serverTimeDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return isPlaying ? (0, _moment["default"])().utc().unix() - serverTimeDelta + _constants.PLAY_DELAY : undefined;
}
function getSceneLayerIds(broadcast) {
  var globalSceneLayers = broadcast.globalSceneLayers;
  var sceneLayers = globalSceneLayers.length ? globalSceneLayers : ['SCENE_LAYER'];
  return sceneLayers.map(function (sl) {
    return sl._id ? sl._id : sl;
  });
}

/**
 * This logic handles the positioning of the background. Backgrounds should
 * always come first and only one can be visible at a time.
 *
 * @param sceneLayerIds
 * @param hidden
 * @param backgroundId
 * @returns {*}
 */
function getUpdatedSceneLayers(sceneLayerIds, hidden, backgroundId) {
  if (!hidden) {
    // the background has been made visible

    if (sceneLayerIds[0] !== 'SCENE_LAYER') {
      // if any other background exists remove it first
      sceneLayerIds.splice(0, 1);
    }

    // make this the current background
    sceneLayerIds.unshift(backgroundId);
  } else {
    // the background has been made invisible. remove it
    sceneLayerIds = sceneLayerIds.filter(function (slId) {
      return !(slId === backgroundId);
    });
  }
  return sceneLayerIds;
}

/**
 * Filters a list of meeting attendees to return only those with their camera turned on.
 * This excludes screen share participants.
 * @param {Object} attendeeTiles - An object where keys are the IDs of attendees in the meeting.
 * @param {Object} attendeeCameraStatus - An object mapping attendee IDs to their camera status (true for on, false for off).
 * @returns {string[]} An array of attendee IDs who have their camera on.
 */
var attendeesWithCameraOn = exports.attendeesWithCameraOn = function attendeesWithCameraOn(attendeeTiles, attendeeCameraStatus) {
  var attendeesInMeetings = Object.keys(attendeeTiles);
  // Exclude screen share attendees
  var cameraAttendeesInMeeting = attendeesInMeetings.filter(function (attendeeId) {
    return !attendeeId.includes('#content');
  });
  return cameraAttendeesInMeeting.filter(function (attendeeId) {
    return attendeeCameraStatus[attendeeId] === true;
  });
};

/**
 * Checks if the number of active cameras in a meeting has exceeded the defined limit.
 * The camera limit can vary based on the meeting vendor (e.g., Agora).
 * @param {Object} attendeeTiles - An object where keys are the IDs of attendees in the meeting.
 * @param {Object} attendeeCameraStatus - An object mapping attendee IDs to their camera status.
 * @returns {boolean} True if the camera limit has been exceeded, false otherwise.
 */
var hasMeetingExceededCameraLimit = exports.hasMeetingExceededCameraLimit = function hasMeetingExceededCameraLimit(attendeeTiles, attendeeCameraStatus) {
  var useAgora = (0, _feature.shouldHaveFeature)('studio.meetingVendor') === _constants.VENDOR_AGORA;
  var cameraLimit = useAgora ? _constants.MAX_AGORA_CAMERA_COUNT : _constants.MAX_CAMERA_COUNT;
  var cameraAttendees = attendeesWithCameraOn(attendeeTiles, attendeeCameraStatus);
  return cameraAttendees.length >= cameraLimit;
};

/**
 * Will adding a camera presenter exceed the camera presenter limit?
 *
 * @param sources
 * @param newSource
 */
function willExceedCameraLimit(sources, newSource) {
  var cameraSources = (0, _sources.getCameraSources)(sources);
  return newSource.type === _constants.CAMERA_PRESENTER && cameraSources.length >= _constants.CAMERA_PRESENTER_LIMIT;
}

/**
 * Will return file in binary format
 *
 * @param backgrounds
 * @param backgroundIdToUpdate
 * @param newUrl
 */
function readFileAsBinary(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      var binaryData = reader.result;
      resolve(binaryData);
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
}

/**
 * Preserves PDF URLs from old sources when updating to new sources
 *
 * This function ensures that when sources are updated, any PDF files in the collection
 * retain their original URLs. This prevents re-renders during source updates.
 *
 * @param {Array} newSources - The new/updated collection of source objects
 * @param {Array} oldSources - The original collection of source objects before update
 * @returns {Array} - Updated collection of sources with PDF URLs preserved from old sources
 */
function retainPDFURLsInSources(newSources, oldSources) {
  return newSources.map(function (source) {
    var oldSource = oldSources.find(function (s) {
      return s._id === source._id;
    });
    if (oldSource && oldSource.type === _constants.PDF_FILE) {
      var _oldSource$value, _source$value;
      return _objectSpread(_objectSpread({}, source), {}, {
        value: _objectSpread(_objectSpread({}, source.value), {}, {
          url: ((_oldSource$value = oldSource.value) === null || _oldSource$value === void 0 ? void 0 : _oldSource$value.url) || ((_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.url)
        })
      });
    }
    return source;
  });
}

/**
 * Returns true if the number of available screen share slots is sufficient for all screen share
 * share requests, else false.
 *
 * @param {array} sources
 * @param {array} pendingKnocks
 * @returns {boolean}
 */
var getShouldApproveScreenShares = exports.getShouldApproveScreenShares = function getShouldApproveScreenShares(pendingKnocks, sources) {
  var screenShareSourceCount = sources.filter(function (source) {
    return source.value !== _constants.UNASSIGNED && source.type === _constants.SCREEN_PRESENTER;
  }).length;
  var screenShareRequestCount = pendingKnocks.filter(function (pendingKnock) {
    return pendingKnock.type === _constants.SCREENSHARE;
  }).length;
  var availableSlots = _constants.SCREEN_PRESENTER_LIMIT - screenShareSourceCount;
  return availableSlots >= screenShareRequestCount;
};